module.exports = __webpack_public_path__ + "img/violetto-xxl.3c7e304d.png";